var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 48 48",
    viewBox: "0 0 48 48",
    id: "Feather",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c15538",
    d: "M46.9,1.3c-0.5-0.5-1.2-0.6-1.9-0.5s-1.3,0.4-1.9,0.7c-3.1,1.5-6.4,3.1-8.2,6c-1.3,2.1-1.8,4.6-2.1,7.1  c-1-2.2-1.1-4.8-0.3-7.1c-0.9,1.7-1.8,3.5-2.6,5.3c-1.9,4.7-2.5,9.9-4,14.8c0.4-2.9-0.2-5.9,0.8-8.6c-1.8,2.3-2.9,5.1-3.3,8  c-3.7,2.5-6.9,6-9,10c-0.1-1.9,0.4-3.7,1.3-5.3C13.1,34,11.3,37.4,11,41c0,0,17.2-3,26.2-26.3c0,0-7.1,28.5-36.3,30.3  c-1.8,0.1,3.5-0.1,5.3-0.2c1.5,0,3-0.1,4.5,0.3c1,0.3,2,0.7,3,1.1c2.7,1,5.6,1.1,8.5,1c-1.4-0.9-2.8-1.8-4-3.1  c6.6,1.8,14.2-0.6,18.5-5.9c-2.8,1.8-6.2,2.4-9.5,2.9c4-0.7,7.2-3.6,9.3-7.1s3.1-7.4,4.2-11.3c-1.7,1-3.6,1.4-5.6,1.7  c0.9-0.2,1.7-0.6,2.4-1c1.7-0.9,3.3-1.7,4.7-3c2.1-2.1,3.1-5.1,4-8c-1.1,1.4-2.3,2.7-3.7,3.9c3.3-3.5,5.1-8.2,4.9-13  C47.5,2.6,47.4,1.8,46.9,1.3z",
    className: "color010101 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeather);
export default __webpack_public_path__ + "static/media/feather.d18634a7eea1646feb5a470fcfc11649.svg";
export { ForwardRef as ReactComponent };